import React from 'react';
import './blog-post.css';
import SwagGraphic from './pictures/swagGraphic.png';

//import reportWebVitals from './reportWebVitals';

const Swag23 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>WiC Swag Pre-Order Form Now Open</h2>
                    <p className="site-post-meta">April 5, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        Hi WiC members!
                        <br></br>
                        <br></br>
                        Do you want to stay cozy while repping WiC? We are now offering branded quarter zip fleece 
                        jackets for pre-order! The quarter zips are black with a small embroidered WiC logo on the chest.
                        <br></br>
                        <br></br>
                        The jackets will be between $36-42 each, paid through Venmo or cash. The cost will be finalized
                        after the pre-order deadline (see the RSVP form for more details). This sale is open to all
                        CSE students. 
                        <br></br>
                        <br></br>
                        Fill out the form by 11:59 pm on April 13th to pre-order your cool WiC swag!
                        <br></br>
                        <br></br>
                        Order form: NOW CLOSED
                        <br></br>
                        <br></br>
                        Note that filling out the form does not complete your order and you will still need to make 
                        payment afterwards. We will send out an email with the final cost on April 14th. If you have 
                        any questions, please email us at wic-officers@cs.washington.edu.
                        <br></br>
                        <br></br>
                        Best, 
                        <br></br>
                        <br></br>
                        WiC
                    </p>
                    <img src={SwagGraphic} alt="Women in Computing Swag Pre-order Form Now Open!"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Swag23;